import { EventosTipoEnum, obtenerIdEventoTipo } from "@shared/enums";
import { IPayloadEtiquetasDTO, PayloadEtiquetasDTO } from "./PayloadEtiquetas.DTO";
import { Nilable } from "@shared/utils";

export interface IActividadDTO{
    created_at: string;
    id: number;
    event_type: string;
    description: string;
    state: string;
    user_id: number;
    user_balance: number;
    amount: number;
    payload: Nilable<IPayloadEtiquetasDTO>;
}

export class ActividadDTO {
    public id = 0;
    public creadoEl = "";
    public tipoEvento = EventosTipoEnum.ANSWER;
    public descripcion = "";
    public estado = "";
    public usuarioId = 0;
    public usuarioBalance = 0;
    public cantidad = 0;
    public payload: Nilable<PayloadEtiquetasDTO>;

    constructor(json: Nilable<Partial<IActividadDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IActividadDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.created_at != null) {
            this.creadoEl = json.created_at;
        }
        if (json.event_type != null) {
            this.tipoEvento = EventosTipoEnum[json.event_type];
        }
        if (json.description != null) {
            this.descripcion = json.description;
        }
        if (json.state != null) {
            this.estado = json.state;
        }
        if (json.user_id != null) {
            this.usuarioId = json.user_id;
        }
        if (json.user_balance != null) {
            this.usuarioBalance = json.user_balance;
        }
        if (json.amount != null) {
            this.cantidad = json.amount;
        }
        if (json.payload != null) {
            this.payload = new PayloadEtiquetasDTO(json.payload);
        }
    }

    public toJSON(): IActividadDTO {
        return {
            id: this.id,
            created_at: this.creadoEl,
            event_type: obtenerIdEventoTipo(this.tipoEvento),
            description: this.descripcion,
            state: this.estado,
            user_id: this.usuarioId,
            user_balance: this.usuarioBalance,
            amount: this.cantidad,
            payload: this.payload?.toJSON() ?? null
        };
    }
}
